import React from 'react';
import Sidebar from '../sidebar';
import classnames from 'classnames';

import { connect } from 'react-redux';
import { navigate } from '@reach/router';
import { generateRouteUrl, generateRandomString } from '../../utils/core';
import { Groups, tabDetailsObjects } from '../../config/admin';
import { Glyphicon, OverlayTrigger, Popover } from 'react-bootstrap';

export class AdminSidebar extends React.Component {

    openAdminTab = (type) => {
        const route = generateRouteUrl({
            tabType: type.slug,
            tenantId: this.props.tenantId,
            options: {
                tabKey: generateRandomString(16),
            },
        });
        navigate(route);
    }

    render() {
        let sidebarItems = Groups && Groups.map((group) => {
            const items = [<li className="heading" key={group.name}>{group.label}</li>];

            if (group.items) {
                return items.concat(group.items.map((item) => {
                    let classes = [];
                    let element = null;

                    const editorType = this.props.editorType === 'admin' ? 'flows' : this.props.editorType;
                    if (item.name === editorType) classes.push('active');
                    classes = classes.concat(item.classes);

                    if (item.href && item.href !== '') {
                        element = (
                            <li key={item.name} className={classes.join(' ')}>
                                <a href={item.href} target="_blank" rel="noopener noreferrer">
                                    <Glyphicon glyph={item.icon} />
                                    <span>{item.label}</span>
                                </a>
                            </li>
                        );
                    } else {
                        element = (
                            <li
                                key={item.name}
                                onClick={() => {
                                    if (item.action) { item.action(item.name); }
                                    if (item.name === 'flows') {
                                        this.openAdminTab(tabDetailsObjects.flows);
                                    } else { 
                                        this.openAdminTab(item); 
                                    }
                                }}
                                className={classes.join(' ')}>
                                <Glyphicon glyph={item.icon} />
                                <span>{item.label}</span>
                            </li>
                        );
                    }

                    if (item.tooltip) {
                        const tooltip = (
                            <Popover id={item.name} className="sidebar-popover">
                                <h5>{item.label}</h5>
                                <div className="popover-content-body">
                                    {item.tooltip}
                                </div>
                            </Popover>
                        );
                        return (
                            <OverlayTrigger
                                key={item.name}
                                rootClose
                                trigger={['hover', 'focus']}
                                placement="right"
                                overlay={tooltip}
                                container={document.querySelector('#manywho-draw')}
                            >
                                {element}
                            </OverlayTrigger>
                        );
                    }

                    return element;
                }));
            }
        });

        if (sidebarItems) {
            sidebarItems = [...sidebarItems];
        }

        const className = classnames({
            hidden: !this.props.isActive,
        });
        
        return <Sidebar class={className}>{sidebarItems}</Sidebar>;
    }
}

const mapStateToProps = ({ currentUser: { tenantId } }) => ({ tenantId });

export default connect(mapStateToProps)(AdminSidebar);
